// npm packages
import React, { useEffect, useState, Fragment, useContext } from "react";
import * as moment from "moment";

// custom pages
import Context from "context/context";
import reportAPI from "apis/panel/reports/reports";
import getemployeelist from "apis/panel/employee/employee"
import "../Reports.css";

// material ui
import Checkbox from '@mui/material/Checkbox';

import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";

import Button from "@mui/material/Button";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import Autocomplete from "@mui/material/Autocomplete";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";

import ReplayIcon from "@mui/icons-material/Replay";
import { styled } from '@mui/system';
import EmployeeAPI from "apis/panel/employee/employee";




const CustomCheckbox = styled(Checkbox)({
  color: ' #0056B2',
  '&.Mui-checked': {
    color: ' #0056B2',
  },
});


export default function RpEmployeeAttendanceDetails({ setDisableDropdown }) {
    
  const { dispatch } = useContext(Context);
   const { state } = useContext(Context);
   

  const {

    getAllManagerEmployees,
    getRPAttendanceDetailsReportAPI
  
  } = reportAPI();

  const { getRpReporteesAPI } = EmployeeAPI();
 
  const [employees, setEmployees] = useState([]);
   const [uniqueEmployees, setUniqueEmployees] = useState([]);
  
  
    const [roleCode, setRoleCode] = useState(state.role.roleCode);
   


  const initialExportObj = {
  startDate: new Date(),
  endDate: new Date(),
  ...(roleCode !== "R001" && roleCode !== "R010" && roleCode !== "R011"
    ?[{ empId: [] }]:[])

};

const [exportObj, setExportObj] = useState(initialExportObj);



  
  const handleGetAllEmployees = async () => {
   
      let res = await getRpReporteesAPI();
    setEmployees(res?.data || []);

    let uniqueEmployees = res?.data?.filter(
      (employee, index, self) =>
        index ===
        self.findIndex(
          (e) =>
            e.employeeId === employee.employeeId &&
            e.employeeCode === employee.employeeCode &&
            e.firstName === employee.firstName &&
            e.lastName === employee.lastName 
           
        )
    );

    setUniqueEmployees(uniqueEmployees || []);

  };



 
  useEffect(() => {
  if (roleCode === "R004") {
      handleGetAllEmployees();
  } 
}, []);
 
 

  const handleExport = async () => {
    let body = {};
    if (!exportObj?.startDate) {
      return;
    }
    if (!exportObj?.endDate) {
      return;
    }
    
    body = {
      startDate: moment(exportObj?.startDate).format("YYYY-MM-DD"),
      endDate: moment(exportObj?.endDate).format("YYYY-MM-DD"),
      
    };
   if( roleCode !== "R001" && roleCode !== "R010" && roleCode !== "R011"){
      if (exportObj?.empId && exportObj?.empId?.length > 0) {
      body = {
        ...body,
        empIds: exportObj?.empId.map((e) => e.employeeId),
      };
    }
  }
    
   
    dispatch({ type: "SET_LOADING", payload: true });
    setDisableDropdown(true);
   
    await getRPAttendanceDetailsReportAPI(body);
    setDisableDropdown(false);
    dispatch({ type: "SET_LOADING", payload: false });
  };

 
  return (
    <Fragment>
      <Grid container spacing={4} sx={{ mt: 2 }}>
        <Grid item xs={12} sm={6} md={6} lg={6}>
          <Box className="labelproj">
            Start Date <span style={{ color: "red" }}>*</span>
          </Box>
          <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
            <DatePicker
              id="startdate"
              name="startdate"
              sx={{ width: "100%" }}
              format="dd/MM/yyyy"
              renderInput={(params) => <TextField {...params} fullWidth />}
              maxDate={exportObj?.endDate}
              value={exportObj?.startDate}
              onAccept={(date) => {
                setExportObj({ ...exportObj, startDate: date });
              }}
            />
          </LocalizationProvider>
        </Grid>

        <Grid item xs={12} sm={6} md={6} lg={6}>
          <Box className="labelproj">
            End Date <span style={{ color: "red" }}>*</span>
          </Box>
          <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
            <DatePicker
              id="enddate"
              name="enddate"
              sx={{ width: "100%" }}
              maxDate={new Date()}
              format="dd/MM/yyyy"
              renderInput={(params) => <TextField {...params} fullWidth />}
              minDate={exportObj?.startDate}
              value={exportObj?.endDate}
              onAccept={(date) => {
                setExportObj({ ...exportObj, endDate: date });
              }}
            />
          </LocalizationProvider>
        </Grid>

{roleCode !== "R001" && roleCode !== "R010" && roleCode !== "R011" && (
            <Grid item xs={12} sm={6} md={6} lg={6}>
          <Box className="label">Employee Name<span style={{ color: "red" }}>*</span></Box>
          <Autocomplete
            multiple
            options={uniqueEmployees}
             
            getOptionLabel={(option) =>
              option && Object.keys(option).length > 0
                ? option?.employeeCode +
                  " - " +
                  option?.firstName +
                  " " +
                  option?.lastName
                : ""
            }
            value={exportObj?.empId || []}
           onChange={(event, newValues) => {
  setExportObj((prev) => ({ ...prev, empId: newValues }));

}}
            renderInput={(params) => <TextField {...params} />}
          />
        </Grid>
)}    
      

      

      </Grid>
      <Grid container>
        <Grid item xs={12} style={{ textAlign: "right", padding: "20px 0px" }}>
          {(
             (exportObj.dept?.length || exportObj.empId?.length) > 0 ||
            !moment(exportObj.startDate).isSame(new Date(), "day") ||
            !moment(exportObj.endDate).isSame(new Date(), "day")) && (
            <Button
              className="reset-btn"
              component="label"
              variant="contained"
              tabIndex={-1}
              startIcon={
                <ReplayIcon style={{ fontSize: 30, verticalAlign: "middle" }} />
              }
              onClick={() => {
        setExportObj({
          dept: [],
          empId:[],
          startDate: new Date(),
          endDate: new Date(),
        });
      
      }}
            >
              Reset
            </Button>
          )}
          
          <Button
            className="download-btn"
            startIcon={
              <DownloadForOfflineIcon
                style={{ fontSize: 30, verticalAlign: "middle" }}
              />
            }
            onClick={handleExport}
          >
            Export
          </Button>
        </Grid>
      </Grid>
    </Fragment>
  );
}
